import { Skeleton } from '@mui/material';

export default function AdditionalStepSkeleton() {
    return (
        <div className="container-height-drawer">
            <div className="content-container">
                <div className='drawer-content'>
                    <Skeleton variant="rectangular" width="100%" height={100} />
                    <Skeleton variant="rectangular" width="80%" height={50} className='mt-4' />
                </div>
                <div className="py-5">
                    <Skeleton variant="rectangular" width="100%" height={50} />
                </div>
            </div>
        </div>
    );
}